import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["viewPurchaseCard", "viewTitle", "viewPurchaseCardBody", "previewCard", "editPurchaseBtn", "deletePurchaseBtn", "8888", "9999"]

  connect() {
    this.controllerName = `financials--products--purchases--records--show`
    this.send_data = { current_user: {}, purchase: {} }
    this.doViewHtml()
  }

  doViewHtml() {
    if (this.getControllerByIdentifier("financials--products--purchases--records--save")) {
      this.getControllerByIdentifier("financials--products--purchases--records--save").stopRefreshing()
    }
    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="viewPurchaseCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4 py-3" style="font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="viewTitle">Nenhuma Contratação Selecionada</h6>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="viewPurchaseCardBody"></div>
                </div>`

    this.getControllerByIdentifier("financials--products--purchases--records--dashboard").viewTarget.innerHTML = html
  }

  editPurchase() {
    this.getControllerByIdentifier("financials--products--purchases--records--save").current_purchase = this.current_purchase
    this.getControllerByIdentifier("financials--products--purchases--records--save").actionMode = "edit"
    this.getControllerByIdentifier("financials--products--purchases--records--save").doFormHtml()
  }

  deletePurchase() {
    var r = confirm("Tem certeza que deseja apagar a Contratação?")
    this.deletePurchaseBtnTarget.disabled = true

    if (r) {
      this.actionMode = "delete"

      this.send_data.purchase.id = this.current_purchase.id
      this.send_data.purchase.active = false

      this.send_data.current_user.current_user_id = this.application.current_user.id

      this.requestDestroy()
    } else {
      this.deletePurchaseBtnTarget.disabled = false
    }

  }

  requestDestroy() {

    var url = "/financials/products/purchases/entities/destroy"
    var method = "DELETE"
    var controller = this
    const init = { method: method, credentials: "same-origin", headers: { "X-CSRF-Token": this.application.token, 'Content-Type': 'application/json' }, body: JSON.stringify(this.send_data) }
    fetch(url, init)
      .then(response => response.json())
      .then(response => {
        if (response.save) {
          var purchase = response.data.cln
          if (purchase.active) {
            controller.application.purchases.forEach((element, i) => {
              if (element.id == purchase.id) {
                controller.application.purchases.splice(controller.application.purchases.indexOf(element), 1, purchase)
              }
            })
          } else {
            controller.application.purchases.forEach((element, i) => {
              if (element.id == purchase.id) {
                controller.application.purchases.splice(controller.application.purchases.indexOf(element), 1)
              }
            })
          }
          controller.getControllerByIdentifier("financials--products--purchases--records--index").doDataTable()
          controller.doViewHtml()
          controller.send_data = { current_user: {}, purchase: {} }
        } else {
          controller.deletePurchaseBtnTarget.disabled = false
        }
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar(response.type, response.message, 2000)
      })
      .catch(error => {
        controller.getControllerByIdentifier("app--helpers--console").console(error)
        controller.getControllerByIdentifier("app--helpers--snackbar").doSnackbar("danger", controller.getControllerByIdentifier("app--helpers--messages").generalError(), 3000)
      })

  }

  goToPurchase(ev) {
    var url = ev.currentTarget.dataset.url

    window.open(url, `_blank`)
  }


  doPurchaseHtml() {
    this.getControllerByIdentifier(`financials--products--purchases--records--save`).stopRefreshing()
    var spaceRow = `<td colspan="10" style="height:2rem;padding-top:1rem;padding-bottom:1rem;" scope="col"></td>`

    if (this.application.permissions.financial_purchase_entities.can_delete && this.current_purchase.journey_status != `finished` && this.current_purchase.journey_status != `canceled`) {
      var deleteBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="deletePurchaseBtn" data-action="click->${this.controllerName}#deletePurchase" type="button">
                            <span class="material-icons f-1p25">delete</span>
                          </button>
                          <span class="mc-tooltiptext">Apagar Contratação</span>`
    } else {
      var deleteBtnHtml = ``
    }

    if (this.application.permissions.financial_purchase_entities.can_update) {
      var editBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-${this.controllerName}-target="editPurchaseBtn" data-action="click->${this.controllerName}#editPurchase" type="button">
                            <span class="material-icons f-1p25">edit</span>
                          </button>
                          <span class="mc-tooltiptext">Editar Contratação</span>`
    } else {
      var editBtnHtml = ``
    }

    this.current_purchase.name = ``
    this.current_purchase.parties.forEach(party => {
      this.current_purchase.name += `<p class="mb-0 f-065 f-bold" data-${this.controllerName}-target="purchasePartyName">${party.party_name}</p>`
    })

    var showBtnHtml = `<button aria-expanded="false" aria-haspopup="true" class="btn btn-outline my-0" data-url="${this.current_purchase.purchase_path}" data-action="click->${this.controllerName}#goToPurchase" type="button">
                        <span class="material-icons f-1p25">launch</span>
                      </button>
                      <span class="mc-tooltiptext">Ver Contratação</span>`


    var html = `<div class="card" style="width:100%;display:relative;" data-${this.controllerName}-target="previewCard" data-action="resize@window->${this.controllerName}#layout">
                  <div class="card-header d-flex align-items-center card-header-table-list f-065">
                    <h6 class="card-title display-4" style="padding:1rem;font-size:110%;margin-bottom:0px;" data-${this.controllerName}-target="previewTitle">Contratação</h6>
                    <div class="card-actions ml-auto py-0 mc-tooltip">
                      ${showBtnHtml}
                    </div>
                    <div class="card-actions py-0 mc-tooltip">
                      ${editBtnHtml}
                    </div>
                    <div class="card-actions py-0 mc-tooltip">
                      ${deleteBtnHtml}
                    </div>
                  </div>
                  <div class="card-body py-0 px-2" style="overflow:auto;" data-${this.controllerName}-target="previewCardBody">
                    <div class="row my-1">
                      <div class="col-12 px-0">
                        <table class="table table-sm table-borderless" style="font-size:80%;">
                          <tbody>
                            <tr>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                              <td style="font-size:80%;height:0.75rem;padding-top:0.5rem;padding-bottom:0.5rem;" scope="col" class="table-10 align-middle"></td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Partes</strong>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.name} <br>
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Produto:</strong>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.product_accrual_name_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Serviço:</strong>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.product_service_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Canal:</strong>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.channel_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Valor:</strong> <br>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.getControllerByIdentifier("app--helpers--numbers").currencyMask(parseInt(this.current_purchase.total_amount * 100))}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Fonte:</strong> <br>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.source_pretty}
                              </td>
                            </tr>

                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Início em:</strong> <br>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.started_at_pretty}
                              </td>
                            </tr>
                            <tr>
                              <th colspan="3" class="f-065 align-middle px-0">
                                <strong>Finalizado em:</strong> <br>
                              </th>
                              <td colspan="5" class="f-065 align-middle px-0 text-left">
                                ${this.current_purchase.finished_at_pretty}
                              </td>
                            </tr>

                            <tr>
                              ${spaceRow}
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>`

    var controller = this
    new Promise(function (resolve) {
      resolve(controller.getControllerByIdentifier("financials--products--purchases--records--dashboard").viewTarget.innerHTML = html)
    }).then(() => {
      controller.previewCardTarget.style.height = ($(window).height() * 0.5) + "px"
      controller.getControllerByIdentifier("app--helpers--elements").tooltip()
    })

  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }

  nameTarget(target) {
    return this.targets.find(target)
  }

  layout() {
    var targets = ["mainCard"]
    var identifier = ""
    this.connect()
    // this.getControllerByIdentifier("app--helpers--layout").resizeMainCard(targets, identifier)
  }

  refreshSaveBtn() {
    var controller = this
    this.refreshTimer = setInterval(function () {
      var len = 0
      controller.validGroupTargets.forEach(element => {
        if (this.fromStringToBoolean(element.dataset.valid) == false) {
          len += 1
        }
      });
      if (len == 0) {
        controller.saveBtnTarget.disabled = false
      } else {
        controller.saveBtnTarget.disabled = true
      }
    }, 200);
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  // new Promise(function (resolve) {
  //   resolve()
  // }).then(() => {
  // }) 

}
